import { JSX } from 'react';
import { BreadcrumbOneLevel } from '@ahc-digital/component-library';
import { useCreateMarketingRenderingHame } from 'src/shared/useCreateMarketingRenderingName';
import { translationClasses } from 'src/shared/TranslationClasses';
import { GetBreadcrumbTitle } from './N11BreadcrumbOneLevel.service';
import { N11BreadcrumbOneLevelProps } from './N11BreadcrumbOneLevel.types';

export const Default = (props?: N11BreadcrumbOneLevelProps): JSX.Element => {
  const { fields, params, rendering } = props || {};
  const parent = fields?.data?.currentPage?.parent;
  const label = GetBreadcrumbTitle(parent);
  const href = parent?.url?.path;
  const marketingRenderingName = useCreateMarketingRenderingHame(
    rendering?.componentName as string
  );

  if (!label || !href) return <></>;

  return (
    <BreadcrumbOneLevel
      label={label}
      href={href}
      id={params?.RenderingIdentifier}
      className={translationClasses(params)}
      data-elastic-exclude=""
      data-component={marketingRenderingName}
    />
  );
};
